/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

/**
 * Public shareable view of an IPSAT 2.0 Archetype Report (Steve 2026-07-07).
 * Mirrors the 1.0 shareable-survey-result page — same header/layout/footer —
 * but renders the 2.0 archetype (primary, overlay, IPSAT score + stage) and
 * offers a cross-link to the 1.0 view via the same SurveyResult id.
 */
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { catchError, of, tap } from 'rxjs';

import { ArchetypeReportService } from '../../../archetype-report/resources/archetype-report.service';
import { ArchetypeWheelComponent } from '../../../archetype-report/components/archetype-wheel/archetype-wheel.component';
import { ErrorHandlerService } from '../../../../services/error-handler.service';

@Component({
  selector: 'app-nexleader-shareable-archetype-report',
  standalone: true,
  imports: [CommonModule, RouterLink, ArchetypeWheelComponent],
  templateUrl: './shareable-archetype-report.component.html'
})
export class NexleaderShareableArchetypeReportComponent implements OnInit {
  routeParams: any;
  archetypeReport: any;
  user: any;
  coach: any;
  loadError: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private archetypeReportService: ArchetypeReportService,
    private errorHandler: ErrorHandlerService
  ) {}

  ngOnInit() {
    this.routeParams = this.route.snapshot.params;

    this.archetypeReportService
      .getShareableVersion(this.routeParams['survey_result_id'])
      .pipe(
        tap((response: any) => {
          this.archetypeReport = response.archetypeReport;
          this.user = response.user;
          this.coach = response.coach;
        }),
        catchError((error) => {
          this.loadError = true;
          this.errorHandler.handleError(error);
          return of(null);
        })
      )
      .subscribe();
  }

  startsWithVowel(text: string): boolean {
    if (!text) return false;
    return /^[aeiou]/i.test(text);
  }

  get primaryContent(): any {
    return this.archetypeReport && this.archetypeReport.content && this.archetypeReport.content.primary;
  }

  get overlayContent(): any {
    return this.archetypeReport && this.archetypeReport.content && this.archetypeReport.content.secondary;
  }
}
